<div class="error-page primary-area h-fluid w-fluid" *transloco="let t, read: 'page.server-error'">
  <div *ngIf="showHeader" class="layout-container">
    <aisno-header><h1></h1></aisno-header>
  </div>
  <div class="error-page-message">
    <img src="/assets/web_development.svg" alt="Card payment" class="m_b-8"/>
    <h2 class="m_b-3">{{t('server-error')}}</h2>
    <div class="body_text text-center centered_text">{{t('error-description.prefix')}}<br>{{t('error-description.suffix')}}</div>
  </div>
</div>